export const Roles = {
	Admin: 'RESEARCHER_SITE_ADMIN',
	Researcher: 'RESEARCHER',
	ApiAccess: 'RESEARCHER_API',
	ProbeBuilder: 'PROBE_BUILDER'
};
